import React, { Fragment } from 'react';
import Modal from '../../../../../components/Modal';
import InfoTable from '../../../../../components/table/InfoTable';
import Select from '../../../../../components/input/Select/Select';
import CountOfTotal from '../../../../../components/CountOfTotal';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import Slider from '../../../../../components/utils/Slider/Slider';
import Img from '../../../../../components/Img/Img';
import {
  MAXIMUM_NUMBER_OF_RETURN_REASON_TEXT,
  ORDER_ITEM_EXCHANGE_TYPE_TEXT,
  ORDER_ITEM_EXCHANGE_TYPE_SELECT_LIST,
} from '../../../../../constants/service/app/orderConstants';
import { setNumberWithComma } from '../../../../../lib/common';
import { formRequiredRules } from '../../../../../lib/formRules';
import './EditExchangeReasonModal.scss';

const EditExchangeReasonModal = (props) => {
  const { form, isOpen, data, closeModal, setData, onSubmit, reasonType, reason } = props;
  const { orderItemInfo, exchangeAttachments } = data;
  const { orderItemId, productName, productPrice, exchangeType, exchangeReason } = orderItemInfo;

  return (
    <Modal
      title="교환 사유 수정"
      isOpen={isOpen}
      width={600}
      height={510}
      isFooter={true}
      okText="교환 사유 수정"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="edit-exchange-reason-modal-wrap">
        <div className="title">선택된 상품 주문 리스트</div>

        <InfoTable className="selected-order-item-list-table">
          <thead>
            <tr>
              <th>상품 주문번호</th>
              <th>상품명</th>
              <th>상품 가격(정가)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="tc">{orderItemId}</td>
              <td className="tc">{productName}</td>
              <td className="tc">{setNumberWithComma(productPrice, '원')}</td>
            </tr>
          </tbody>
        </InfoTable>

        <div className="title">변경하기 전 내역</div>

        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc">기존 교환 사유</td>
              <td className="tl" colSpan={3}>
                {ORDER_ITEM_EXCHANGE_TYPE_TEXT[exchangeType]}
              </td>
            </tr>
            <tr>
              <td className="label tc">
                <span>기존 상세 사유</span>
              </td>
              <td className="tl" colSpan={3}>
                {exchangeReason}
              </td>
            </tr>
          </tbody>
        </InfoTable>

        <div className="title">변경할 내역</div>

        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc">교환 사유 선택</td>
              <td className="tl" colSpan={3}>
                <Select
                  list={ORDER_ITEM_EXCHANGE_TYPE_SELECT_LIST}
                  onChange={(id) =>
                    setData({
                      name: 'reasonType',
                      value: id,
                    })
                  }
                  value={reasonType}
                  size="default"
                  isTable={true}
                />
              </td>
            </tr>
            <tr>
              <td className="label tc">
                <span>상세 사유 입력</span>
                <CountOfTotal content={reason} maxCnt={MAXIMUM_NUMBER_OF_RETURN_REASON_TEXT} />
              </td>
              <td className="tl" colSpan={3}>
                <TextAreaForm
                  form={form}
                  name="reason"
                  rules={[formRequiredRules(true, null)]}
                  initialValue={reason}
                  onChange={(value) =>
                    setData({
                      name: 'reason',
                      value,
                    })
                  }
                  maxLength={MAXIMUM_NUMBER_OF_RETURN_REASON_TEXT}
                />
              </td>
            </tr>
          </tbody>
        </InfoTable>

        {/*교환 요청 사진이 없으면 렌더링하지 않는다.*/}
        {exchangeAttachments.length > 0 ? (
          <Fragment>
            <div className="title">교환 요청 상세 이미지</div>
            <div className="img-area">
              <Slider list={exchangeAttachments} item={(url) => <Img height={500} src={url} />} />
            </div>
          </Fragment>
        ) : undefined}
      </div>
    </Modal>
  );
};

export default EditExchangeReasonModal;
